const sms = {
  content: "短信内容",
  sendTime: "发送时间",
  result: "结果",
  searchLabelWidth: '70px'
} 
export default sms